<div class="container mt-4">
  <!-- Add Project Form -->
  <!-- Filter Section -->
  <div class="card p-3 mb-3">
    <div class="row g-2 align-items-end">
      <div class="col-md-3">
        <label>Customer (exact)</label>
        <select class="form-control" [(ngModel)]="filterDtls.customerCode" (change)="loadProjects()">
          <option value="">All</option>
          <option *ngFor="let customer of customers" [value]="customer.CustomerShortCode">{{ customer.CustomerShortCode
            }}</option>
        </select>
      </div>
      <div class="col-md-3">
        <label>Customer short code search</label>
        <input
          type="text"
          class="form-control"
          placeholder="Filter by customer code…"
          [(ngModel)]="customerSearch"
          (ngModelChange)="onCustomerSearchChange()"
        />
      </div>
      <div class="col-md-3">
        <label>Workflow status</label>
        <select class="form-control" [(ngModel)]="filterDtls.lifecycle" (change)="loadProjects()">
          <option value="">All</option>
          <option value="IN_PROGRESS">In progress</option>
          <option value="RELEASED">Released</option>
          <option value="ARCHIVED">Archived</option>
        </select>
      </div>
      <div class="col-md-3 text-muted small">
        {{ displayedProjectList.length }} of {{ projectList.length }} project(s)
      </div>
    </div>
  </div>

  <!-- Project List -->
  <div class="card p-3">
    <h5>Project List</h5>
    <table class="table table-bordered table-hover">
      <thead>
        <tr>
          <th role="button" (click)="setSort('ProjectShortCode')">Short Code{{ sortIndicator('ProjectShortCode') }}</th>
          <th role="button" (click)="setSort('ProjectName')">Name{{ sortIndicator('ProjectName') }}</th>
          <th role="button" (click)="setSort('CustomerShortCode')">Customer{{ sortIndicator('CustomerShortCode') }}</th>
          <th>Linked lesson</th>
          <th role="button" (click)="setSort('projectLifecycleStatus')">Workflow{{ sortIndicator('projectLifecycleStatus') }}</th>
          <th role="button" (click)="setSort('slidenos')">No of slides{{ sortIndicator('slidenos') }}</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let project of displayedProjectList">
          <td>{{ project.ProjectShortCode }}</td>
          <td>{{ project.ProjectName }}</td>
          <td>{{ project.CustomerShortCode }}</td>
          <td class="text-muted small">
            <ng-container *ngIf="project.lessonUserId != null && project.lessonId != null; else noLesson">
              user {{ project.lessonUserId }}, lesson {{ project.lessonId }}
            </ng-container>
            <ng-template #noLesson>—</ng-template>
          </td>
          <td>
            <select
              class="form-select form-select-sm"
              [value]="project.projectLifecycleStatus || 'IN_PROGRESS'"
              (change)="onProjectLifecycleChange(project, $event)"
            >
              <option value="IN_PROGRESS">In progress</option>
              <option value="RELEASED">Released</option>
              <option value="ARCHIVED">Archived</option>
            </select>
          </td>
          <td>{{ project.slidenos }}</td>
          <td>
            <div class="d-flex flex-wrap align-items-center gap-2">
              <button type="button" class="btn btn-outline-primary" (click)="Manage_slides(project.ProjectShortCode)">Manage slides</button>
              <select
                class="form-select form-select-sm"
                style="max-width: 11rem;"
                [ngModel]="exportLanguageFor(project.ProjectShortCode)"
                (ngModelChange)="onExportLanguageChange(project.ProjectShortCode, $event)"
                [disabled]="transferExportingCode === project.ProjectShortCode"
                title="Export language for transfer zip (same as Edit slide lines; saved for this project)">
                <option value="">EN — source</option>
                <option *ngFor="let lang of languages" [value]="lang.LanguageShortCode">
                  {{ lang.LanguageShortCode }} — {{ lang.LanguageName }}
                </option>
              </select>
              <button
                type="button"
                class="btn btn-outline-secondary"
                [title]="'Create transfer files (' + exportLanguageLabel(project.ProjectShortCode) + ')'"
                [disabled]="transferExportingCode === project.ProjectShortCode"
                (click)="createTransferFiles(project.ProjectShortCode)">
                {{ transferExportingCode === project.ProjectShortCode ? (transferExportingMessage || 'Working…') : 'Create transfer file' }}
              </button>
              <button
                type="button"
                class="btn btn-outline-secondary"
                title="Create and download a ZIP from the existing transfer file and project assets"
                [disabled]="transferExportingCode === project.ProjectShortCode"
                (click)="downloadTransferZip(project.ProjectShortCode)">
                {{ transferExportingCode === project.ProjectShortCode ? (transferExportingMessage || 'Working…') : 'Download transfer ZIP' }}
              </button>
            </div>
          </td>
        </tr>
        <tr *ngIf="!loading && displayedProjectList.length === 0">
          <td colspan="7" class="text-muted text-center">No projects match the current filters.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>